import React from 'react';

const Facebook = React.memo(({ color, ...props }) => <svg width="44" height="44" viewBox="0 0 44 44" {...props}>
    <circle cx="22" cy="22" r="22" style={{ fill: color }} />
    <path d="M20.25,33h3.89V23h3.24l.49-3.91H24.14v-2.5c0-1.13.3-1.9,1.87-1.9h2v-3.5A25.61,25.61,0,0,0,25.1,11c-2.88,0-4.85,1.82-4.85,5.17V19H17v4h3.25V33Z" style={{ fill: '#fff' }} />
</svg>);

export default Facebook;

Facebook.defaultProps = {
    width: '34px',
    height: '34px',
    color: '#3060a3',
};